var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTicketIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_31293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98231 3.44581L7.31374 3.6001C7.37429 3.8636 7.38186 4.13651 7.33601 4.40296C7.29015 4.66942 7.19178 4.9241 7.04663 5.1522C6.90147 5.3803 6.71243 5.57727 6.49047 5.73166C6.26852 5.88605 6.01809 5.99478 5.75374 6.05153C5.2177 6.16429 4.65882 6.06224 4.19722 5.76733C3.73561 5.47242 3.40814 5.00817 3.28517 4.47438L1.94803 4.74867C1.76466 4.78868 1.5913 4.86545 1.43843 4.97434C1.28556 5.08323 1.15635 5.22198 1.05861 5.38221C0.960872 5.54244 0.89663 5.72082 0.869766 5.90658C0.842902 6.09233 0.853974 6.2816 0.902314 6.46296C0.902314 6.46296 1.51946 9.32581 2.23946 12.5487M20.8395 3.42867C20.737 3.71732 20.577 3.98218 20.3692 4.20718C20.1614 4.43218 19.9101 4.61266 19.6305 4.73766C19.3508 4.86267 19.0487 4.92961 18.7425 4.93443C18.4362 4.93924 18.1322 4.88184 17.8488 4.76568C17.5654 4.64953 17.3085 4.47705 17.0937 4.25869C16.8789 4.04033 16.7107 3.78064 16.5992 3.49535C16.4878 3.21007 16.4354 2.90512 16.4452 2.59898C16.4551 2.29285 16.527 1.99191 16.6566 1.71438L15.268 1.06296C14.8972 0.908436 14.4805 0.906374 14.1082 1.05722C13.7359 1.20806 13.4381 1.49964 13.2795 1.86867L7.51946 15.4287L6.76517 17.143C6.61065 17.5137 6.60859 17.9305 6.75943 18.3028C6.91027 18.6751 7.20185 18.9729 7.57089 19.1315L14.5309 22.0972C14.9017 22.2518 15.3184 22.2538 15.6907 22.103C16.063 21.9521 16.3608 21.6606 16.5195 21.2915L23.0337 5.96581C23.1774 5.60943 23.1813 5.21198 23.0446 4.85286C22.9079 4.49374 22.6408 4.19941 22.2966 4.02867L20.8395 3.42867Z",
    stroke: "#0050C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_31293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ticket-icon.33256c27.svg";
export { ForwardRef as ReactComponent };